<template>
  <div id="webinarList">
    <div class="pc description">
      <h3 class="description__title" v-html="seriesMeetingInfo.articleCategoryInfo.tempTitle"></h3>
      <div class="description__content">
        <div class="primary" v-html="seriesMeetingInfo.articleCategoryInfo.subtitle"></div>
        <div v-html="seriesMeetingInfo.articleCategoryInfo.describe"></div>
      </div>
    </div>
    <div class="pc webinarCon">
      <div class="submitAll" @click="submitAll()" v-if="LoginStatus === 1">全选</div>
      <div class="signUp" @click="submitFun()">报名参会</div>
      <div class="webinarList">
        <div class="trailNoticeCon">
          <div class="title"></div>
          <ul class="list">
            <li v-for="(item, index) of dataList" :key="item.id" :class="{ active: index === current }">
              <div v-bind:class="{ inputhide: LoginStatus === 0 }" class="wap-div">
                <input type="checkbox" :id="'trailNotice2020' + index" v-model="item.subselected" name="trailNotice" :disabled="item.selectedStatus"/>
                <label :for="'trailNotice2020' + index" :class="{ selectd: item.selectedStatus }"></label>
              </div>
              <div :class="{ redclass: LoginStatus === 1 }" class="traildot traildiv wap-div" @click="clickArticle(item,index)">
                <span>{{ item.showTitle }}</span>
              </div>
              <img class="arrowsimg" src="../assets/arrows.png" alt=""/>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="Wap description">
      <h3 class="description__title" v-html="seriesMeetingInfo.articleCategoryInfo.tempTitle"></h3>
      <div class="description__content">
        <div class="primary" v-html="seriesMeetingInfo.articleCategoryInfo.subtitle"></div>
        <div v-html="seriesMeetingInfo.articleCategoryInfo.describe"></div>
      </div>
    </div>
    <login class="Wap" v-if="isWap"/>
    <div class="Wap webinarCon">
      <div class="submitAll" @click="submitAll()" v-if="LoginStatus === 1">全选</div>
      <div class="signUp" @click="submitFun()">报名参会</div>
      <div class="webinarList">
        <div class="trailNoticeCon">
          <div class="title"></div>
          <ul class="list">
            <li v-for="(item, index) of dataList" :key="item.id" v-bind:class="{ active: item.isOpen }">
              <div v-bind:class="{ inputhide: LoginStatus === 0 }" class="wap-div">
                <input type="checkbox" :id="'trailNotice2020wap' + index" v-model="item.subselected" name="trailNotice" :disabled="item.selectedStatus"/>
                <label :for="'trailNotice2020wap' + index" :class="{ selectd: item.selectedStatus }"></label>
              </div>
              <div :class="{ redclass: LoginStatus === 1, traildiv: LoginStatus === 1 }" class="traildot wap-div" @click="clickArticle(item,index)">
                <span>{{ item.showTitle }}</span>
              </div>
              <img :class="{ arrowsimg: !item.isOpen }" @click="clickArticle(item,index)" src="../assets/close.png"/>
              <img :class="{ arrowsimg: item.isOpen }" @click="clickArticle(item,index)" src="../assets/open.png"/>
              <div class="clear"></div>
              <webinar-details :item-info="item" v-if="item.isOpen" class="detailshow"/>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Article, Url, Config } from "smarket-pithy";
import WebinarDetails from "./WebinarDetails";
import Login from "./Login";
import { getCookie } from "../utils/public";
import bus from "../utils/eventBus";

export default {
  name: "WebinarList",
  data: function() {
    return {
      seriesMeetingInfo: new Article.articleCategory(
        Url.urlParams.articleCategoryId
      ),
      meetingList: new Article.articleList(Url.urlParams.articleCategoryId),
      isLoaded: false,
      current: 0,
      dataList: [], //直播数据
      checkedAll: false //是否全选
    };
  },
  components: {
    WebinarDetails,
    Login
  },
  created: function() {
    this.getSeriesMeetingInfo();
  },
  mounted() {
    this.getMeetingList();
  },
  computed: {
    isWap() {
      return $(document).width() <= 750;
    },
    LoginStatus() {
      return this.$store.state.loginStatus;
    },
    userInfo() {
      return this.$store.state.info;
    }
  },
  watch: {
    LoginStatus() {
      if (this.LoginStatus && this.isLoaded) {
        this.getMeetingList(true);
      }
    }
  },
  methods: {
    setDocumentTitle(title) {
      document.title = title;
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement("iframe");
        i.src = "/favicon.ico";
        i.style.display = "none";
        i.onload = function() {
          setTimeout(function() {
            i.remove();
          }, 9);
        };
        document.body.appendChild(i);
      }
    },
    getSeriesMeetingInfo() {
      this.seriesMeetingInfo.beforeInit = seriesMeetingInfo => {
        this.setDocumentTitle(seriesMeetingInfo.title);
        let _summary = seriesMeetingInfo.summary;
        // tempTitle
        let lastIndex = _summary.indexOf("\n\n");
        seriesMeetingInfo.tempTitle = _summary.substr(0, lastIndex);
        // subtitle
        _summary = _summary
          .substr(lastIndex, _summary.length)
          .replace(/(^\s*)/g, "");
        lastIndex = _summary.indexOf("\n\n");
        seriesMeetingInfo.subtitle = _summary
          .substr(0, lastIndex)
          .replace(/\n/g, "<br>");
        // describe
        _summary = _summary.substr(lastIndex + 2, _summary.length);
        seriesMeetingInfo.describe = _summary.replace(/\n/g, "<br>");
        this.$store.commit(
          "setBannerImgUrl",
          seriesMeetingInfo.shareImgRealPath
        );
      };
      this.seriesMeetingInfo.load();
    },

    getMeetingList(isMy = false) {
      return this.getArticleList().then(() => {
        let meetingIds = [];
        this.meetingList.articleList.forEach(meeting => {
          meetingIds.push(meeting.summary);
        });
        console.log(this.meetingList.articleList);
        return $.ajax({
          url: window.config.api.gateway.general + "/api/webinar/query",
          type: "post",
          dataType: "json",
          data: {
            tenantId: Config("tenantId"),
            sort: { startTime: "asc" },
            status: 5,
            videoType: 1,
            fieldsDisplay: ["preTitle"],
            start: 0,
            num: 50,
            ...(isMy
              ? {
                  isSelectSignUp: 1,
                  sess: getCookie("sess")
                }
              : {
                  ids: meetingIds
                })
          }
        }).then(data => {
          let items = data.body.content.items || [];
          if (!isMy) {
            console.log("全部", data.body.content);
            items.forEach(item => {
              item.selectedStatus = false; // 判断是否已报名（禁用选择框）
              item.subselected = false; // 选择状态（false为未选中，ture为已选中）
              item.isOpen = false;
              let _article = this.meetingList.articleList.find(
                article => article.summary == item.id
              );
              item.order = _article.order;
              item.showTitle =
                (item.customFieldItems.preTitle || "") + item.title;
            });
            items.sort((a, b) => b.order - a.order);
            this.dataList = items;
            if (this.dataList.length) {
              this.$store.commit("getinstanceId", this.dataList[0].instanceId);
            }
            if (this.LoginStatus) {
              this.getMeetingList(true).then(() => {
                this.$store.commit("setIsLoading", false);
              });
            } else {
              this.$store.commit("setIsLoading", false);
            }
            this.isLoaded = true;
            this.$nextTick(() => {
              $(".traildot").dotdotdot({
                ellipsis: "\u2026 ",
                truncate: "letter",
                keep: ".todydots",
                watch: true
              });
            });
          } else {
            console.log("已报名的", data.body.content);
            items.forEach(myMeeting => {
              this.dataList.forEach(item => {
                if (item.id === myMeeting.id) {
                  item.selectedStatus = true;
                }
              });
            });
          }
        });
      });
    },

    getArticleList() {
      if (this.meetingList.articleList.length) {
        return Promise.resolve(this.meetingList.articleList);
      } else {
        return this.meetingList.load();
      }
    },

    clickArticle: function(data, index) {
      this.current = index;
      this.$store.commit("getinstanceId", data.instanceId);

      data.isOpen = !data.isOpen;
    },

    submitAll: function() {
      this.checkedAll = !this.checkedAll;
      this.dataList.forEach(item => {
        if (!item.selectedStatus) {
          item.subselected = this.checkedAll;
        }
      });
    },

    submitFun: function() {
      if (this.LoginStatus === 1) {
        let meetingListPromises = [];
        this.dataList.forEach(item => {
          if (item.subselected && !item.selectedStatus) {
            meetingListPromises.push(this.submitData(item));
          }
        });
        if (meetingListPromises.length) {
          Promise.all(meetingListPromises).then(() => {
            bus.$emit("showToast", "报名成功");
          });
        } else {
          bus.$emit("showToast", "请勾选您想要报名的课程");
        }
      } else {
        bus.$emit("showToast", "想要报名课程，请先“注册”或“登录”");
      }
    },

    submitData: function(item) {
      return $.ajax({
        url: window.config.api.gateway.general + "/customForm/action",
        type: "post",
        dataType: "json",
        data: {
          instanceId: item.instanceId,
          customFormId: item.customFormId,
          globalUserId: getCookie("globalUserId"),
          sess: getCookie("sess"),
          name: this.userInfo.name,
          memberId: this.userInfo.memberId,
          items: [
            { fieldName: "name", value: this.userInfo.name },
            {
              fieldName: "mobile",
              value: this.userInfo.mobile || this.userInfo.InternationalMobile
            },
            {
              fieldName: "email",
              value: this.userInfo.emailNew || this.userInfo.email
            },
            {
              fieldName: "company",
              value: this.userInfo.company || this.userInfo.enterprise
            },
            {
              fieldName: "enterprise",
              value: this.userInfo.enterprise || this.userInfo.company
            },
            {
              fieldName: "addr",
              value: this.userInfo.f_20 || this.userInfo.addr
            },
            { fieldName: "firstName", value: this.userInfo.firstName },
            { fieldName: "lastName", value: this.userInfo.lastName },
            { fieldName: "m_qudao", value: $.cookie("ARC") || "" },
            { fieldName: "f_5053", value: this.userInfo.f_5053[0] },
            {
              fieldName: "zhiwei",
              value: this.userInfo.zhiwei ? this.userInfo.zhiwei[0] : ""
            },
            { fieldName: "country", value: this.userInfo.country },
            { fieldName: "city", value: this.userInfo.city },
            { fieldName: "address", value: this.userInfo.address },
            { fieldName: "dAddress", value: this.userInfo.dAddress },
            { fieldName: "postCode", value: this.userInfo.postCode },
            {
              fieldName: "province",
              value: this.userInfo.province ? this.userInfo.province[0] : ""
            }
          ],
          url: window.location.href,
          referenceUrl: window.location.href,
          ver: "v2.0.1",
          linkId: 1,
          tc: Url.urlParams.tc
        }
      }).then(data => {
        if (data.body.result === 0) {
          item.selectedStatus = true;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.pc {
  display: block;
}

.Wap {
  display: none;
  width: pxToRem(750);
}

.clear {
  clear: both;
}

#webinarList {
  flex: 0 0 54%;
}

.description {
  margin: 0 18px 26px 3px;
  padding-bottom: 26px;
  border-bottom: 1px solid #f0f0f0;

  &__title {
    position: relative;
    font-size: 24px;
    line-height: 30px;
    color: #524f56;
    padding-left: 16px;
    margin: 0 0 10px;

    &:before {
      content: "";
      display: block;
      width: 5px;
      height: 20px;
      background-color: #e90029;
      position: absolute;
      left: 0;
      top: 4px;
    }
  }

  &__content {
    color: #777;
    font-size: 13px;
    line-height: 21px;

    .primary {
      font-weight: bold;
      color: #524f56;
      font-size: 15px;
    }
  }
}

.webinarCon {
  position: relative;

  .submitAll {
    position: absolute;
    background-color: rgba(251, 232, 235, 0.4);
    color: #ec001f;
    border: 1px solid rgb(251, 232, 235);
    border-radius: 2px;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
    width: 96px;
    text-align: center;
    right: 140px;
    cursor: pointer;
  }

  .signUp {
    position: absolute;
    background-color: #e90029;
    color: #f7f7f7;
    border-radius: 2px;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
    width: 112px;
    text-align: center;
    right: 20px;
    cursor: pointer;
  }

  .webinarList {
    margin-top: 1px;

    .trailNoticeCon {
      .title {
        height: 32px;
        color: #e90029;
        margin-left: 10px;
        padding: 3px 0;
        background: url(../assets/title-meetingList.png) left center no-repeat;
        background-size: 101px 18px;
      }

      .list {
        margin-top: 15px;
        padding: 0;

        li {
          overflow: hidden;
          list-style: none;
          font-size: 15px;
          color: #524f56;
          line-height: 25px;
          padding-left: 12px;
          min-height: 40px;
          max-height: 80px;
          position: relative;

          .traildiv {
            margin-right: 44px;
            display: block;
            float: left;
            width: 92%;
          }

          .wap-div {
            max-height: 80px;
            display: block;
            float: left;
            padding-top: 7px;
            padding-bottom: 7px;
            min-height: 40px;
            cursor: pointer;

            span {
              margin-right: 10px;
            }

            label {
              margin-top: 5px;
            }

            .selectd {
              background: url("../assets/checkbox-active2.png") no-repeat !important;
            }
          }

          .redclass {
            width: 89%;
          }

          .inputhide {
            display: none;
          }

          > .arrowsimg {
            display: none;
            position: absolute;
            width: 18px;
            height: 11px;
            right: 25px;
            top: 15px;
          }

          &.active {
            background: #f7f7f7;
            color: #e90029;

            > .arrowsimg {
              display: block;
            }
          }
        }

        li:hover {
          background: #f7f7f7;
        }
      }
    }
  }
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"] + label {
  background: url("../assets/checkbox.png") no-repeat;
  background-size: 100% 100%;
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-top: 3px;
  margin-right: 10px;
}

input[type="checkbox"]:checked + label {
  background: url("../assets/checkbox-active.png") no-repeat;
}

.Hide {
  display: none;
}

/*WAP端*/
@media screen and (max-width: 750px) {
  .pc {
    display: none;
  }

  .Wap {
    display: block;
    width: pxToRem(750);
  }

  .description {
    width: pxToRem(680);
    padding-bottom: pxToRem(46);
    margin: 0 pxToRem(35) pxToRem(40);

    &__title {
      font-size: pxToRem(34);
      line-height: pxToRem(40);
      padding-left: pxToRem(15);
      margin: 0 0 pxToRem(20) 0;

      &:before {
        width: pxToRem(5);
        height: pxToRem(30);
        margin-top: pxToRem(-3);
        background-color: #e90029;
        top: pxToRem(8);
      }
    }

    &__content {
      color: #777;
      font-size: pxToRem(20);
      line-height: pxToRem(30);

      .primary {
        font-weight: normal;
        color: #524f56;
        font-size: pxToRem(24);
        line-height: pxToRem(35);
        margin-bottom: pxToRem(15);
      }
    }
  }

  .webinarCon {
    width: pxToRem(680);
    margin: 0 pxToRem(35);

    .submitAll {
      background-color: rgba(251, 232, 235, 0.4);
      color: #ec001f;
      border: 1px solid rgb(251, 232, 235);
      border-radius: pxToRem(10);
      height: pxToRem(42);
      line-height: pxToRem(38);
      font-size: pxToRem(24);
      width: pxToRem(150);
      right: pxToRem(180);
    }

    .signUp {
      background: url("../assets/wapsubmit.png") no-repeat;
      background-size: pxToRem(175) pxToRem(42);
      color: #ec001f;
      height: pxToRem(42);
      line-height: pxToRem(38);
      font-size: pxToRem(24);
      width: pxToRem(175);
      padding-left: pxToRem(15);
      right: pxToRem(-10);
    }

    .webinarList {
      margin-top: 1px;

      .trailNoticeCon {
        margin-top: pxToRem(34);

        .title {
          color: #e90029;
          margin-left: 0;
          height: pxToRem(42);
          padding: pxToRem(4) 0;
          background: url(../assets/title-meetingList-wap.png) left center
            no-repeat;
          background-size: pxToRem(142) pxToRem(26);

          img {
            display: block;
            height: pxToRem(28);
          }
        }

        .list {
          margin-top: 15px;
          padding: 0;

          li {
            font-size: pxToRem(24);
            min-height: pxToRem(30);
            max-height: initial;
            line-height: pxToRem(40);

            .traildot {
              width: 95%;
              padding-top: pxToRem(18);
            }

            .detailshow {
              width: pxToRem(680);
              margin-left: -12px;
            }

            .traildiv {
              margin-top: pxToRem(5);
              margin-right: pxToRem(45);
              display: block;
              float: left;
              width: 85% !important;
            }

            .wap-div {
              max-height: pxToRem(120);
              display: block;
              float: left;

              span {
                margin-right: 10px;
              }

              label {
                margin-top: 6px;
              }

              .selectd {
                background: url("../assets/checkbox-wap-active2.png") no-repeat !important;
                background-size: 100% 100% !important;
              }
            }

            .redclass {
              width: 89%;
            }

            .inputhide {
              display: none;
            }

            > img {
              display: none;
            }

            .arrowsimg {
              display: block;
              width: pxToRem(21);
              height: pxToRem(13);
              top: pxToRem(32);
              right: pxToRem(15);
            }

            &.active {
              background: #f0f0f0;
              color: #e90029;
            }
          }

          li:hover {
            background: #f0f0f0;
          }
        }
      }
    }
  }

  input[type="checkbox"] {
    display: none;
  }

  input[type="checkbox"] + label {
    background: url("../assets/checkbox-wap.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    width: pxToRem(30);
    height: pxToRem(31);
    margin-top: 3px;
    margin-right: 10px;
  }

  input[type="checkbox"]:checked + label {
    background: url("../assets/checkbox-wap-active.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
